var _path;
import * as React from "react";
function SvgExtension(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.19 19.238h-2.285v-6.095a3.057 3.057 0 00-3.048-3.048h-6.095V7.81A3.81 3.81 0 0016.952 4a3.81 3.81 0 00-3.81 3.81v2.285H7.049a3.044 3.044 0 00-3.033 3.048v5.79h2.27a4.117 4.117 0 014.115 4.115 4.117 4.117 0 01-4.114 4.114H4v5.79A3.057 3.057 0 007.048 36h5.79v-2.286a4.117 4.117 0 014.114-4.114 4.117 4.117 0 014.115 4.114V36h5.79a3.057 3.057 0 003.048-3.048v-6.095h2.285a3.81 3.81 0 003.81-3.81 3.81 3.81 0 00-3.81-3.809z"
  })));
}
export default SvgExtension;